/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Logistics_Capture_Dispatch_MetadataInputs */

const en_orders_logistics_capture_dispatch_metadata = /** @type {(inputs: Orders_Logistics_Capture_Dispatch_MetadataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Capture dispatch metadata before shipment moves through the in-transit stage.`)
};

const es_orders_logistics_capture_dispatch_metadata = /** @type {(inputs: Orders_Logistics_Capture_Dispatch_MetadataInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Captura metadatos de despacho antes de que el envio pase a la etapa En transito.`)
};

/**
* | output |
* | --- |
* | "Capture dispatch metadata before shipment moves through the in-transit stage." |
*
* @param {Orders_Logistics_Capture_Dispatch_MetadataInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_logistics_capture_dispatch_metadata = /** @type {((inputs?: Orders_Logistics_Capture_Dispatch_MetadataInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Logistics_Capture_Dispatch_MetadataInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_logistics_capture_dispatch_metadata(inputs)
	return es_orders_logistics_capture_dispatch_metadata(inputs)
});